query ApprovalHistorySearchFilterTotals(
  $isQueuedSearch: Boolean
  $searchRequest: SearchRequestInput
  $filterBusinessUnitId: UUID
  $filterStatusTypeId: Int
  $isHistorySearch: Boolean
  $approverUserId: UUID
  $filterApprovalId: UUID
  $isApproverUserApprover: Boolean
  $isApproverUserRequester: Boolean
  $isOnlyUnsignedApprovals: Boolean
  $isLinkSearch: Boolean
  $filterDepartmentId: UUID
) {
  approvalHistorySearchFilterTotals(
    filterBusinessUnitId: $filterBusinessUnitId
    filterDepartmentId: $filterDepartmentId
    filterStatusTypeId: $filterStatusTypeId
    isHistorySearch: $isHistorySearch
    approverUserId: $approverUserId
    filterApprovalId: $filterApprovalId
    isApproverUserApprover: $isApproverUserApprover
    isApproverUserRequester: $isApproverUserRequester
    isOnlyUnsignedApprovals: $isOnlyUnsignedApprovals
    isLinkSearch: $isLinkSearch
    searchRequest: $searchRequest
    isQueuedSearch: $isQueuedSearch
  ) {
    totalCount1
    totalAmount1
  }
}
